import React, { useEffect } from "react";
import { MdClose } from "react-icons/md";

// Shared modal shell — replaces the two independent hand-rolled modal
// implementations that existed in Admin_page.jsx (Change Password used a
// dedicated CSS class system; Branch Selection re-built an overlay/panel
// from scratch with inline dark-mode ternaries). `rounded-2xl shadow-2xl`
// intentionally matches the selector index.css uses for the app's global
// glass-modal treatment, so the panel inherits that automatically.
export default function Modal({ open, onClose, title, children, footer, maxWidthClassName = "max-w-[480px]" }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/40 backdrop-blur-sm p-4 animate-fade-in"
      onClick={onClose}
    >
      <div
        className={`w-full ${maxWidthClassName} rounded-2xl shadow-2xl border border-white/70 dark:border-slate-700/60 animate-slide-up max-h-[90dvh] flex flex-col`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={typeof title === "string" ? title : undefined}
      >
        {title && (
          <div className="flex items-center justify-between gap-3 px-6 py-5 border-b border-black/5 dark:border-white/5 shrink-0">
            <h2 className="m-0 text-lg font-extrabold text-slate-900 dark:text-slate-50 tracking-tight">
              {title}
            </h2>
            <button
              onClick={onClose}
              className="flex h-9 w-9 items-center justify-center rounded-xl text-slate-500 hover:bg-rose-50 hover:text-rose-500 dark:text-slate-400 dark:hover:bg-rose-500/10 dark:hover:text-rose-300 transition-colors"
              aria-label="Close"
            >
              <MdClose className="text-xl" />
            </button>
          </div>
        )}
        <div className="p-6 overflow-y-auto">{children}</div>
        {footer && (
          <div className="flex justify-end gap-3 px-6 py-4 border-t border-black/5 dark:border-white/5 shrink-0">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
